import axios from 'axios';
import moment from 'moment';

const config = {
  development: {
    baseUrl: process.env.REACT_APP_API_DEV_URL || window.location.origin,
    expiryWindow: 600
  },
  staging: {
    baseUrl: process.env.REACT_APP_API_STG_URL,
    expiryWindow: 600
  },
  production: {
    baseUrl: process.env.REACT_APP_API_PRD_URL,
    expiryWindow: 600
  }
};

const ENV = process.env.REACT_APP_NODE_ENV || "development";

const currentConfig = config[ENV];

let instance = null;

export class Api {

  baseUrl = null;
  apiUrl = null;
  expiryWindow = 600;
  isEnvProd = ENV != "development";
  cachedResponses = {};

  constructor() {
    if(instance) {
      return instance;
    }

    this.baseUrl = currentConfig.baseUrl;
    this.expiryWindow = currentConfig.expiryWindow;
    this.apiBasePath = '/api/v1';
    this.apiBase = `${this.baseUrl}${this.apiBasePath}`;

    instance = this;
    return instance;
  }

  logout() {
    localStorage.removeItem("apiAccessToken");
  }

  loggedIn() {
    return !!localStorage.getItem('apiAccessToken');
  }

  refreshAccessToken() {
    const attributes = {
      access_token: localStorage.getItem("apiAccessToken"),
      refresh_token: localStorage.getItem("refreshToken")
    };
    return axios.post(
      this.apiBase + "/auth",
      attributes, {
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(response => this.handleAuthError(response))
      .then(({ data: response }) => this.setTokens(response));
  }

  authHeaders() {
    return {
      "Authorization": "Bearer " + localStorage.getItem("apiAccessToken")
    };
  }

  handleAuthError(response) {
    if (response.status === 401) {
      localStorage.removeItem("apiAccessToken");
      window.location.reload();
    }
    return response;
  }

  ensureFreshTokens() {
    /*const delta = (localStorage.getItem("expiresAt") - new Date().getTime()) / 1000;
    if(delta < this.expiryWindow) // 10 min?
      return this.refreshAccessToken();
    else return Promise.resolve();
    */
   return Promise.resolve();
  }

  setTokens(response) {
    for(var [key, value] of Object.entries(response)) {
      if(key === 'expiresIn') {
        const expireDate = moment();
        expireDate.add(value, 'seconds');
        localStorage.setItem('expiresAt', expireDate.toDate().getTime());
      } else {
        localStorage.setItem(key, value);
      }
    }
    return response;
  }

  authWithOps(authResult) {
    return axios.post(this.apiBase + "/auth", {
      code: authResult.code,
      client: "web"
    },{
      headers: {"Content-Type": "application/json"}
    })
      .then(({ data: response }) => this.setTokens(response));
  }


  serialize( filter ) {
    return Object.keys(filter).map(
      key => `${key}=${encodeURIComponent(filter[key])}`
    ).join('&');
  }

  needsSlash(path) {
    if (path[0] === '/') {
      return path;
    }
    return '/' + path;
  }

  get(resource, filter = {}, cached = false) {
    let filterParams = this.serialize(filter);
    filterParams = filterParams ? '?'+filterParams : filterParams;
    const urlToFetch = this.needsSlash(`${resource}${filterParams}`);
    if (cached) {
      const data = this.cachedResponses[urlToFetch];
      if (data) {
        return Promise.resolve(data);
      }
    }

    return this.ensureFreshTokens()
      .then(() => axios.get(this.apiBase + urlToFetch, {
        headers: this.authHeaders()
      }))
      .then(response => {
        if (cached) {
          this.cachedResponses[urlToFetch] = response;
        }
        return response;
      })
      .catch((response) => this.handleAuthError(response));
  }

  patch(resource, data) {
    return this.ensureFreshTokens()
      .then(
        () => axios.patch(this.apiBase + this.needsSlash(resource), data, {
          headers: this.authHeaders()
        })
      ).catch((response) => this.handleAuthError(response));
  }

  post(resource, data) {
    return this.ensureFreshTokens()
      .then(
        () => axios.post(this.apiBase + this.needsSlash(resource), data, {
          headers: this.authHeaders()
        })
      ).catch((response) => this.handleAuthError(response));
  }

  delete(resource) {
    return this.ensureFreshTokens()
      .then(
        () => axios.delete(this.apiBase + this.needsSlash(resource), {
          headers: this.authHeaders()
        })
      ).catch((response) => this.handleAuthError(response));
  }
};
